<template>
  <div class="pwd-box">
    <input
      ref="fake"
      :type="show ? 'text' : 'text'"
      :style="inputStyle"
      v-model="mask"
      autocomplete="off"
      autocorrect="off"
      spellcheck="false"
      placeholder="请输入密码"
      @input="onInput"
      @compositionstart="composing = true"
      @compositionend="onCompositionEnd"
    />
    <Icon
      :type="show ? 'ios-eye-outline' : 'ios-eye-off-outline'"
      class="backIconEye"
      @click="toggleShow"
    />
    <!-- <button type="button" @click="toggleShow">
      {{ show ? "🙈" : "🐵" }}
    </button> -->
  </div>
</template>

<script>
export default {
  name: "VirtualPwdInput",
  props: {
    value: {
      // v-model 绑定
      type: String,
      default: "",
    },
  },
  data() {
    return {
      realPwd: this.value, // 真实密码
      mask: "", // 显示用的掩码
      show: false, // 是否明文
      composing: false, // 中文输入锁定
    };
  },
  computed: {
    // ✅ 定义允许字符的 regex（提取为计算属性，便于复用）
    allowedCharsRegex() {
      return /[A-Za-z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g;
    },
    inputStyle() {
      // 用 CSS 把明文变成黑点
      return this.show
        ? {}
        : {
          fontFamily: "text-security-disc",
          WebkitTextSecurity: "disc",
          MozTextSecurity: "disc",
        };
    },
  },
  watch: {
    realPwd(val) {
      this.$emit("input", val); // v-model 更新父组件
    },
    value(val) {
      if (val !== this.realPwd) {
        this.realPwd = val;
        this.render();
      }
    },
  },
  mounted() {
    this.render();
  },
  methods: {
    onPaste(e) {
      e.preventDefault();
      const pasteData = (e.clipboardData || window.clipboardData).getData('text');
      const pos = this.$refs.fake.selectionStart;
      this.realPwd = this.realPwd.slice(0, pos) + pasteData + this.realPwd.slice(pos);
      this.render();
      this.setCursor(pos + pasteData.length);
    },
    render() {
      this.mask = this.show ? this.realPwd : "•".repeat(this.realPwd.length);
    },
    setCursor(pos) {
      this.$nextTick(() => {
        this.$refs.fake.setSelectionRange(pos, pos);
      });
    },
    onInput(e) {
      if (this.composing) return;

      const val = e.target.value;
      const pos = this.$refs.fake.selectionStart;
      const oldLen = this.realPwd.length;
      const newLen = val.length;

      if (newLen > oldLen) {
        // ✅ 新增内容（可能来自粘贴或单个字符输入）
        const insertedLen = newLen - oldLen;
        const insertedText = val.slice(pos - insertedLen, pos);

        // ✅ 核心修复：根据规则过滤粘贴内容
        const filtered =
          insertedText.match(this.allowedCharsRegex)?.join("") || "";

        // ✅ 计算过滤后的实际插入长度（用于光标定位）
        const actualInsertedLen = filtered.length;

        this.realPwd =
          this.realPwd.slice(0, pos - insertedLen) +
          filtered +
          this.realPwd.slice(pos - insertedLen);

        // ✅ 修复光标位置（考虑过滤后长度变化）
        const cursorPos = pos - insertedLen + actualInsertedLen;
        this.render();
        this.setCursor(cursorPos);
      } else if (newLen < oldLen) {
        // 删除逻辑保持不变
        const delLen = oldLen - newLen;
        this.realPwd =
          this.realPwd.slice(0, pos) + this.realPwd.slice(pos + delLen);
        this.render();
        this.setCursor(pos);
      } else {
        // 长度不变（可能是替换）
        this.render();
        this.setCursor(pos);
      }

      // if (newLen > oldLen) {
      //   // ✅ 修复：计算插入长度，提取所有插入的字符
      //   const insertedLen = newLen - oldLen;
      //   const insertedText = val.slice(pos - insertedLen, pos);
      //   this.realPwd =
      //     this.realPwd.slice(0, pos - insertedLen) +
      //     insertedText +
      //     this.realPwd.slice(pos - insertedLen);
      // } else if (newLen < oldLen) {
      //   // 删除逻辑保持不变
      //   const delLen = oldLen - newLen;
      //   this.realPwd =
      //     this.realPwd.slice(0, pos) + this.realPwd.slice(pos + delLen);
      // }

      // this.render();
      // this.setCursor(pos);
      // if (this.composing) return;

      // const val = e.target.value;
      // const pos = this.$refs.fake.selectionStart;
      // const oldLen = this.realPwd.length;
      // const newLen = val.length;

      // if (newLen > oldLen) {
      //   // 新增
      //   const char = val[pos - 1];
      //   this.realPwd =
      //     this.realPwd.slice(0, pos - 1) + char + this.realPwd.slice(pos - 1);
      // } else if (newLen < oldLen) {
      //   // 删除
      //   const delLen = oldLen - newLen;
      //   this.realPwd =
      //     this.realPwd.slice(0, pos) + this.realPwd.slice(pos + delLen);
      // }

      // this.render();
      // this.setCursor(pos);
    },
    onCompositionEnd(e) {
      this.composing = false;

      // 防止 e.data 为 null / undefined
      const rawData = e.data || "";
      const pos = this.$refs.fake.selectionStart;

      // 只过滤掉中文、不可见字符，保留字母、数字及常见符号
      const allowed = /[A-Za-z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g;
      const filtered = rawData.match(allowed)?.join("") || "";

      // 计算删除长度（避免 undefined 拼接）
      const delLen = rawData.length;
      this.realPwd =
        this.realPwd.slice(0, pos - delLen) +
        filtered +
        this.realPwd.slice(pos);

      this.render();
      this.setCursor(pos - delLen + filtered.length);
    },
    toggleShow() {
      this.show = !this.show;
      this.render();
      this.setCursor(this.$refs.fake.selectionStart);
    },
  },
};
</script>

<style scoped>
.pwd-box {
  display: inline-flex;
  align-items: center;
}

.backIcon {
  position: absolute;
  font-size: 20px;
  width: 22px;
  left: 10px;
  top: 6px;
  color: #888;
}

.backIconEye {
  position: absolute;
  font-size: 20px;
  width: 22px;
  right: 10px;
  top: 7px;
  color: #888;
}

input {
  font-size: 14px;
  border: none;
  outline: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  width: 100%;
  line-height: 34px;
  height: 36px;
  display: block;
  /* text-indent: 10px; */
  position: absolute;
  left: 0;
  top: 0;
  border-radius: 2px;
  border: 1px solid #eee;
  background: transparent;
  -webkit-transition: all 0.2s linear;
  transition: all 0.2s linear;
  text-indent: 38px;
}

input:focus {
  border: 1px solid #2a75ed;
}

button {
  margin-left: 4px;
  border: none;
  background: transparent;
  cursor: pointer;
  position: absolute;
  right: 5px;
  top: 2px;
}
</style>